import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { Select } from 'primeng/select'
import { IftaLabel } from 'primeng/iftalabel'
import { CurrencyService } from '@app/shared/services/currency.service'
import { toSignal } from '@angular/core/rxjs-interop'
import { AlbertBaseControlDirective } from '@directives/albert-base-control.directive'

@Component({
  selector: 'albert-currency-select',
  standalone: true,
  imports: [ReactiveFormsModule, Select, IftaLabel],
  templateUrl: './albert-currency-select.component.html',
  styleUrl: './albert-currency-select.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertCurrencySelectComponent extends AlbertBaseControlDirective {
  public readonly editable = input<boolean>(false)

  private readonly currencyService = inject(CurrencyService)
  private readonly currencies = toSignal(this.currencyService.currencies$, { initialValue: [] })

  public readonly currencyOptions = computed(() =>
    this.currencies().map(c => ({ label: c.currency, value: c.currency }))
  )
}
